import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '强国复兴有我';
const baseUrl = '2022XLBT';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'welcome',
      name: `${baseUrl}-welcome`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Welcome.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rank',
      name: `${baseUrl}-rank`,
      component: () => import('./pages/Rank.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'listPage',
      name: `${baseUrl}-listPage`,
      component: () => import('./pages/ListPage.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'register',
      name: `${baseUrl}-register`,
      component: () => import('./pages/Register.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'user',
      name: `${baseUrl}-user`,
      component: () => import('./pages/User.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
